import { vec2 } from 'gl-matrix';
import { Intersection } from './Intersection.js';
export { Intersects };
class Intersects {
    static circleCircle(centerA, radiusA, centerB, radiusB, inclusive = true) {
        const l = vec2.sqrLen(vec2.subtract([0, 0], centerB, centerA)), r = radiusA + radiusB;
        return inclusive ? l <= r * r : l < r * r;
    }
    static circleStraight(centerA, radiusA, p1, p2, inclusive = true) {
        const r = vec2.subtract([0, 0], p2, p1), d = Math.abs((vec2.cross([0, 0, 0], r, vec2.subtract([0, 0], p1, centerA)))[2] / vec2.length(r));
        return inclusive ? d <= radiusA : d < radiusA;
    }
    static segmentSegment(lineAPoint1, lineAPoint2, lineBPoint1, lineBPoint2, lineAInclusive = true, lineBInclusive = true, noCollisionIfBothEndpoints = false, collinearIsFalse = true) {
        const i = Intersection.segmentSegment(lineAPoint1, lineAPoint2, lineBPoint1, lineBPoint2, lineAInclusive, lineBInclusive, noCollisionIfBothEndpoints);
        return i !== undefined && ((i === -1) !== collinearIsFalse);
    }
    static raySegment(rayPoint, rayDirection, segmentPoint1, segmentPoint2, rayInclusive = true, segmentInclusive = true, noCollisionIfBothEndpoints = false, collinearIsFalse = true) {
        const i = Intersection.raySegment(rayPoint, rayDirection, segmentPoint1, segmentPoint2, rayInclusive, segmentInclusive, noCollisionIfBothEndpoints);
        return i !== undefined && ((i === -1) !== collinearIsFalse);
    }
}
//# sourceMappingURL=Intersects.js.map